import { render, staticRenderFns } from "./desktop.vue?vue&type=template&id=00b33a18&scoped=true&"
import script from "./desktop.vue?vue&type=script&lang=js&"
export * from "./desktop.vue?vue&type=script&lang=js&"
import style0 from "./desktop.vue?vue&type=style&index=0&id=00b33a18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b33a18",
  null
  
)

component.options.__file = "desktop.vue"
export default component.exports